import { notificationsReducer } from './notifications';

export default notificationsReducer;
